module.exports = __webpack_public_path__ + "static/media/photo.966e4eed.svg";